var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Arrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#005e9d",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.03516,13.98828c-0.40625,-0.00781 -0.77734,0.23438 -0.94141,0.60547c-0.16016,0.375 -0.07812,0.80859 0.20703,1.09766l7.97656,8.30859h-43.25391c-0.35937,-0.00391 -0.69531,0.18359 -0.875,0.49609c-0.18359,0.3125 -0.18359,0.69531 0,1.00781c0.17969,0.3125 0.51563,0.5 0.875,0.49609h43.25391l-7.97656,8.30859c-0.38281,0.39844 -0.36719,1.03125 0.03125,1.41406c0.39844,0.38281 1.03125,0.37109 1.41406,-0.03125l10.26563,-10.69141l-10.26562,-10.69141c-0.18359,-0.19922 -0.44141,-0.3125 -0.71094,-0.32031z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Arrow1);
export default __webpack_public_path__ + "static/media/icons8-arrow1.22edc924e8b6fb481dd1df8533d3b4ad.svg";
export { ForwardRef as ReactComponent };